export default __webpack_public_path__ + "static/upload-file-6f787b75d58b2324954f757a62173fcf.gif";